import avaliacaoPsicossocialService from '@/services/avaliacaoPsicossocial'

const initialState = () => ({
  perguntas: [],
  respostas: {},
  mapeamentoPsicossocial: {},
  mapeamentosEmpresa: null
})

const state = initialState()

const getters = {
  perguntasPorTipo: state => id => {
    return state.perguntas.filter(pergunta => pergunta.categoria.id === id)
  },
  mapeamentoPsicossocial: state => {
    return state.mapeamentoPsicossocial
  }
}

const mutations = {
  RESET: state => {
    Object.assign(state, initialState())
  },
  SET_PERGUNTAS: (state, perguntas) => {
    state.perguntas = perguntas
  },
  SET_RESPOSTAS: (state, respostas) => {
    Object.keys(respostas).forEach(key => {
      const r = respostas[key]

      if (r && typeof r.value === 'object' && r.value !== null) {
        respostas[key] = {
          ...r,
          value: r.value.value || ''
        }
      }
    })

    state.respostas = respostas
  },
  SET_MAPEAMENTO_PSICOSSOCIAL: (state, mapeamentoPsicossocial) => {
    state.mapeamentoPsicossocial = mapeamentoPsicossocial
  },
  SET_MAPEAMENTOS_EMPRESA: (state, mapeamentosEmpresa) => {
    state.mapeamentosEmpresa = mapeamentosEmpresa
  }
}

const actions = {
  setMapeamentoPsicossocial: ({ commit }, mapeamentoPsicossocial) => {
    commit('SET_MAPEAMENTO_PSICOSSOCIAL', mapeamentoPsicossocial)
  },
  fetchMapeamentosEmpresa: async ({ commit }) => {
    try {
      const { data } = await avaliacaoPsicossocialService.getMapeamentosEmpresa()
      commit('SET_MAPEAMENTOS_EMPRESA', data.mapeamentos)
    } catch (error) {
      console.error('Erro ao buscar mapeamentos da empresa:', error)
    }
  },
  preparaAvaliacaoPsicossocial: async ({ commit, state, dispatch }, idEmpresaFuncionario) => {
    try {
      const { mapeamentoPsicossocial } = state

      const { data } = await avaliacaoPsicossocialService.getPerguntasAndRespostas(
        idEmpresaFuncionario,
        mapeamentoPsicossocial
      )
      const { perguntas, respostas } = data

      commit('SET_PERGUNTAS', perguntas)
      commit('SET_RESPOSTAS', respostas)

      return data
    } catch (error) {
      console.log(error)
      dispatch('app/showErrorMessage', error.response.data.message, {
        root: true
      })

      throw error
    }
  },
  finalizarAvaliacaoPsicossocial: async ({ state, dispatch }, idEmpresaFuncionario) => {
    const { respostas, mapeamentoPsicossocial } = state

    try {
      await avaliacaoPsicossocialService.finalizarAvaliacaoPsicossocial({
        idEmpresaFuncionario,
        respostas,
        mapeamentoPsicossocial
      })

      return true
    } catch (error) {
      dispatch('app/showErrorMessage', error.response.data.message, {
        root: true
      })

      return false
    }
  }
}

export default { namespaced: true, state, getters, mutations, actions }
